import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import locale from 'element-ui/lib/locale/lang/en';
import i18n from './lang';
import 'animate.css';

Vue.config.productionTip = false;
Vue.use(ElementUI,{locale});

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
